<div
  class="flex-column container flex w-auto sm:w-full lg:flex-row"
  *ngIf="contactService.contactUsContent"
>
  <div
    class="contact-section flex-column align-items-center lg:align-items-start justify-content-center flex text-center lg:text-start"
  >
    <h3 class="contact-section-title primary-font">
      {{ contactService.contactUsContent.title }}
    </h3>
    <p class="contact-section-description secondary-font">
      {{ contactService.contactUsContent.description }}
    </p>
    <button
      class="contact-button primary-font"
      pButton
      (click)="goToContactUs()"
    >
      {{ contactService.contactUsContent.contact_button_text }}
    </button>
  </div>
  <div class="info">
    <div class="info-section">
      <h4 class="info-section-title secondary-font">
        {{ contactService.contactUsContent.phone_number_title }}
      </h4>
      <h5 class="info-description info-phone primary-font">
        {{ contactService.contactUsContent.phone_number }}
      </h5>
    </div>
    <div class="info-section">
      <h4 class="info-section-title secondary-font">
        {{ contactService.contactUsContent.emait_title }}
      </h4>
      <h5 class="info-description info-email primary-font">
        {{ contactService.contactUsContent.email_address }}
      </h5>
    </div>
    <div class="info-section">
      <h4 class="info-section-title secondary-font">
        {{ contactService.contactUsContent.opening_hours_title }}
      </h4>
      <h5 class="info-description info-open-hours primary-font">
        {{ contactService.contactUsContent.opening_hours }}
      </h5>
    </div>
  </div>
</div>
